module.exports = __webpack_public_path__ + "img/logo.965cfd14.svg";